import { type ReactNode } from 'react';
import { Group, Title, Text, ActionIcon } from '@mantine/core';
import { IconArrowLeft } from '@tabler/icons-react';
import { Link } from '@tanstack/react-router';

interface PortalPageHeaderProps {
  title: string;
  subtitle?: string;
  action?: ReactNode;
  backLink?: string;
}

export function PortalPageHeader({ title, subtitle, action, backLink }: PortalPageHeaderProps) {
  return (
    <Group justify='space-between' align='flex-start' wrap='nowrap' mb='md'>
      <Group gap='sm' wrap='nowrap' align='center'>
        {backLink && (
          <ActionIcon
            component={Link}
            to={backLink}
            variant='subtle'
            color='gray'
            size={44}
            radius='md'
            aria-label='Go back'
          >
            <IconArrowLeft size={20} />
          </ActionIcon>
        )}
        <div>
          <Title order={3} fw={700} lh={1.2}>
            {title}
          </Title>
          {subtitle && (
            <Text size='sm' c='dimmed' mt={2}>
              {subtitle}
            </Text>
          )}
        </div>
      </Group>
      {action && <Group gap='xs'>{action}</Group>}
    </Group>
  );
}
